import React from 'react'

import App from './App'
import './config/i18n'
import reportWebVitals from './reportWebVitals'
import { initMockServiceWorker } from './test/msw'
import * as ReactDOMClient from 'react-dom/client'

initMockServiceWorker()

const container = document.getElementById('root')

// Create a root.
const root = ReactDOMClient.createRoot(container)

// 保存原始的 console.log、console.error 和 console.warn
const originalConsoleLog = console.log
const originalConsoleError = console.error
const originalConsoleWarn = console.warn

// 覆寫 console.log
console.log = (...args) => {
  // 忽略包含 [MSW] 的日誌
  if (args.some(arg => typeof arg === 'string' && arg.includes('[MSW]'))) {
    return // 直接返回，不執行原始的 console.log
  }
  originalConsoleLog(...args) // 調用原始的 console.log
}

// 覆寫 console.error
console.error = (...args) => {
  if (args.some(arg => typeof arg === 'string' && arg.includes('[MSW]'))) {
    return // 忽略包含 [MSW] 的錯誤日誌
  }
  originalConsoleError(...args) // 調用原始的 console.error
}

// 覆寫 console.warn
console.warn = (...args) => {
  if (args.some(arg => typeof arg === 'string' && arg.includes('[MSW]'))) {
    return // 忽略包含 [MSW] 的警告日誌
  }
  if (/MUI/.test(args[0])) return // 忽略 MUI 的警告
  originalConsoleWarn(...args) // 調用原始的 console.warn
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
